import { get } from 'lodash/fp';
import Cookies from 'js-cookie';
import getPCPUrl from '../getPCPUrl';

export default itemId => (dispatch, getState) => {
  const { estimateBuilder } = getState();

  const item = get(`entities.items.byId.${itemId}`, estimateBuilder);
  const designId = get('designId', item);
  const design = get(`entities.designs.byId.${designId}`, estimateBuilder);
  const designName = get('name', design);
  const itemName = get('name', item);

  const estimateMode = {
    designId,
    designName,
    itemId,
    itemName,
    action: 'edit',
  };

  localStorage.setItem('estimateMode', JSON.stringify(estimateMode));
  /*
   This cookie added to be consumed by THD Nucleus PCP Experience
    since local storage is not cross domains.
  */
  const { designModeCookieDomain } = window.pageContextJavascript;
  const cookieSettings = { domain: designModeCookieDomain || undefined, sameSite: 'none', secure: true };
  Cookies.set('designMode', JSON.stringify(estimateMode), cookieSettings);

  window.location.href = dispatch(getPCPUrl(itemId));
};
